import { styled } from "@mui/material/styles";

import { TextFieldVariant } from "../types";

interface FloatingLabelProps {
  focused: boolean;
  hasValue: boolean;
  variant: TextFieldVariant;
  color: string;
  backgroundColor: string;
}

export const FloatingLabel = styled("label")<FloatingLabelProps>(
  ({ theme, focused, hasValue, variant, color, backgroundColor }) => ({
    color,
    position: "absolute",
    left:
      variant === "search"
        ? "46px" // Extra space for search icon
        : "18px",
    top: "50%",
    transform: "translateY(-50%)",
    padding: "0 4px",
    pointerEvents: "none", // So clicks pass through to the input
    transition: theme.transitions.create(["top", "font-size", "transform", "color", "background-color"]),
    backgroundColor,
    transformOrigin: "left top",
    fontSize: "1rem",
    fontFamily: ["Barlow", "Roboto", "Helvetica Neue", "Arial", "sans-serif"].join(","),

    // When focused or has value, move the label up
    ...(focused || hasValue
      ? {
        top: 0,
        transform: "translateY(-50%) scale(0.75)",
        zIndex: 1,
      }
      : {}),
  })
);
